import template from './employment_listing_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EmploymentListingHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmploymentListingHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmploymentListingHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

// Register the dialog
export default {
	name: 'EmploymentListingHelp',
	dialog_class: EmploymentListingHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employment_listing_help',
	provider: 'ps'
};
